<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Ponto de Apoio
          </p>
          <div class="heading-elements">
            <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
          </div>
        </div>

        <div class="box-body">
					<div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="cd_ponto_apoio">Código <sup class="text-danger">* </sup></label>
              <input id="cd_ponto_apoio" v-model="registro.cd_ponto_apoio" v-mask="'NNNNN'" type="text" style="text-transform:uppercase" class="form-control input-number" v-bind:class="{ 'box-input-required': errors.cd_ponto_apoio }">
              <span v-show="errors.cd_ponto_apoio != null" class="help-inline">{{ errors.cd_ponto_apoio }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="descricao">Descrição <sup class="text-danger">* </sup></label>
              <input id="descricao" v-model="registro.descricao" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.descricao }">
              <span v-show="errors.descricao != null" class="help-inline">{{ errors.descricao }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="idc_status">Status <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                <option value="1">Ativo</option>
                <option value="2">Inativo</option>
              </select>
              <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="cnpj">CNPJ <sup class="text-danger">* </sup></label>
              <input id="cnpj" v-model="registro.cnpj" v-mask="'##.###.###/####-##'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.cnpj }">
              <span v-show="errors.cnpj != null" class="help-inline">{{ errors.cnpj }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="horario_atend_ini">Horário atendimento <sup class="text-danger">* </sup></label>
              <br/>
              <select id="horario_atend_ini" v-model="registro.horario_atend_ini" class="form-control combo-hora" v-bind:class="{ 'box-input-required': errors.horario_atend }">
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select> &nbsp;&nbsp; às &nbsp;&nbsp;
              <select id="horario_atend_fim" v-model="registro.horario_atend_fim" class="form-control combo-hora" v-bind:class="{ 'box-input-required': errors.horario_atend }">
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select>
              <span v-show="errors.horario_atend != null" class="help-inline">{{ errors.horario_atend }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="raio_atuacao">Raio de atuação (KM) <sup class="text-danger">* </sup></label>
              <input id="raio_atuacao" v-model="registro.raio_atuacao" v-mask="'###'" type="text" class="form-control input-number" v-bind:class="{ 'box-input-required': errors.raio_atuacao }">
              <span v-show="errors.raio_atuacao != null" class="help-inline">{{ errors.raio_atuacao }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="horario_indisponivel_ini">Horário indisponível</label>
              <br/>
              <select id="horario_indisponivel_ini" v-model="registro.horario_indisponivel_ini" class="form-control combo-hora" v-bind:class="{ 'box-input-required': errors.horario_indisponivel }">
                <option value="">-</option>
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select> &nbsp;&nbsp; às &nbsp;&nbsp;
              <select id="horario_indisponivel_fim" v-model="registro.horario_indisponivel_fim" class="form-control combo-hora" v-bind:class="{ 'box-input-required': errors.horario_indisponivel }">
                <option value="">-</option>
                <option value="00:00">00:00</option>
                <option value="00:30">00:30</option>
                <option value="01:00">01:00</option>
                <option value="01:30">01:30</option>
                <option value="02:00">02:00</option>
                <option value="02:30">02:30</option>
                <option value="03:00">03:00</option>
                <option value="03:30">03:30</option>
                <option value="04:00">04:00</option>
                <option value="04:30">04:30</option>
                <option value="05:00">05:00</option>
                <option value="05:30">05:30</option>
                <option value="06:00">06:00</option>
                <option value="06:30">06:30</option>
                <option value="07:00">07:00</option>
                <option value="07:30">07:30</option>
                <option value="08:00">08:00</option>
                <option value="08:30">08:30</option>
                <option value="09:00">09:00</option>
                <option value="09:30">09:30</option>
                <option value="10:00">10:00</option>
                <option value="10:30">10:30</option>
                <option value="11:00">11:00</option>
                <option value="11:30">11:30</option>
                <option value="12:00">12:00</option>
                <option value="12:30">12:30</option>
                <option value="13:00">13:00</option>
                <option value="13:30">13:30</option>
                <option value="14:00">14:00</option>
                <option value="14:30">14:30</option>
                <option value="15:00">15:00</option>
                <option value="15:30">15:30</option>
                <option value="16:00">16:00</option>
                <option value="16:30">16:30</option>
                <option value="17:00">17:00</option>
                <option value="17:30">17:30</option>
                <option value="18:00">18:00</option>
                <option value="18:30">18:30</option>
                <option value="19:00">19:00</option>
                <option value="19:30">19:30</option>
                <option value="20:00">20:00</option>
                <option value="20:30">20:30</option>
                <option value="21:00">21:00</option>
                <option value="21:30">21:30</option>
                <option value="22:00">22:00</option>
                <option value="22:30">22:30</option>
                <option value="23:00">23:00</option>
                <option value="23:30">23:30</option>
              </select>
              <span v-show="errors.horario_indisponivel != null" class="help-inline">{{ errors.horario_indisponivel }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="min_horas_agendamento">Horas antecedência p/ agendamento <sup class="text-danger">* </sup></label>
              <input id="min_horas_agendamento" v-model="registro.min_horas_agendamento" v-mask="'###'" type="text" class="form-control input-number" v-bind:class="{ 'box-input-required': errors.min_horas_agendamento }">
              <span v-show="errors.min_horas_agendamento != null" class="help-inline">{{ errors.min_horas_agendamento }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="idc_agenda_hora">Habilitar seleção de horário <sup class="text-danger">* </sup></label>
              <br/>
              <toggle-button id="idc_agenda_hora" v-model="registro.idc_agenda_hora"/>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="dt_inicio_operacao">Data de início de operação</label>
              <input id="dt_inicio_operacao" v-model="registro.dt_inicio_operacao" v-mask="'##/##/####'" type="text" class="form-control input-number" v-bind:class="{ 'box-input-required': errors.dt_inicio_operacao }">
              <span v-show="errors.dt_inicio_operacao != null" class="help-inline">{{ errors.dt_inicio_operacao }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="capacidade_atend_hora">Capacidade atendimento de cada técnico/{{ registro.idc_agenda_hora ? 'hora' : 'dia' }} <sup class="text-danger">* </sup></label>
              <input id="capacidade_atend_hora" v-model="registro.capacidade_atend_hora" v-mask="'###'" type="text" class="form-control input-number" v-bind:class="{ 'box-input-required': errors.capacidade_atend_hora }">
              <span v-show="errors.capacidade_atend_hora != null" class="help-inline">{{ errors.capacidade_atend_hora }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="telefone">Telefone <sup class="text-danger">* </sup></label>
              <input id="telefone" v-model="registro.telefone" v-mask="'(##) ####-#####'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.telefone }">
              <span v-show="errors.telefone != null" class="help-inline">{{ errors.telefone }}</span>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="end_cep">CEP <sup class="text-danger">* </sup></label>
              <input v-model="registro.end_cep" v-mask="'##.###-###'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_cep }" @keyup="pesquisarCEP()">
              <span v-show="errors.end_cep != null" class="help-inline">{{ errors.end_cep }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_logradouro">Logradouro <sup class="text-danger">* </sup></label>
              <input id="end_logradouro" v-model="registro.end_logradouro" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_logradouro }">
              <span v-show="errors.end_logradouro != null" class="help-inline">{{ errors.end_logradouro }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="end_numero">Número <sup class="text-danger">* </sup></label>
              <input id="end_numero" v-model="registro.end_numero" v-mask="'##########'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_numero }">
              <span v-show="errors.end_numero != null" class="help-inline">{{ errors.end_numero }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_complemento">Complemento </label>
              <input id="end_complemento" v-model="registro.end_complemento" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_complemento }">
              <span v-show="errors.end_complemento != null" class="help-inline">{{ errors.end_complemento }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="end_bairro">Bairro <sup class="text-danger">* </sup></label>
              <input id="end_bairro" v-model="registro.end_bairro" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_bairro }">
              <span v-show="errors.end_bairro != null" class="help-inline">{{ errors.end_bairro }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_cidade">Cidade <sup class="text-danger">* </sup></label>
              <input id="end_cidade" v-model="registro.end_cidade" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_cidade }">
              <span v-show="errors.end_cidade != null" class="help-inline">{{ errors.end_cidade }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="end_uf">UF <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.end_uf" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.end_uf }">
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AM">AM</option>
                <option value="AP">AP</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MG">MG</option>
                <option value="MS">MS</option>
                <option value="MT">MT</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="PR">PR</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="RS">RS</option>
                <option value="SC">SC</option>
                <option value="SE">SE</option>
                <option value="SP">SP</option>
                <option value="TO">TO</option>
              </select>
              <span v-show="errors.end_uf != null" class="help-inline">{{ errors.end_uf }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_pais">País <sup class="text-danger">* </sup></label>
              <select id="idc_status" v-model="registro.end_pais" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.end_pais }">
                <option value="0639">ARGENTINA</option>
                <option value="0973">BOLIVIA</option>
                <option value="1058">BRASIL</option>
                <option value="1589">CHILE</option>
                <option value="1694">COLOMBIA</option>
                <option value="2399">EQUADOR</option>
                <option value="2496">ESTADOS UNIDOS</option>
                <option value="4936">MEXICO</option>
                <option value="5860">PARAGUAI</option>
                <option value="5894">PERU</option>
                <option value="8451">URUGUAI</option>
                <option value="8508">VENEZUELA</option>
              </select>
              <span v-show="errors.end_pais != null" class="help-inline">{{ errors.end_pais }}</span>
            </div>

            <div class="form-group col-12 col-md-6">
              <label for="end_latitude">Latitude </label>
              <input id="end_latitude" v-model="registro.end_latitude" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_latitude }">
              <span v-show="errors.end_latitude != null" class="help-inline">{{ errors.end_latitude }}</span>
            </div>
            <div class="form-group col-12 col-md-6">
              <label for="end_longitude">Longitude</label>
              <input id="end_longitude" v-model="registro.end_longitude" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.end_longitude }">
              <span v-show="errors.end_longitude != null" class="help-inline">{{ errors.end_longitude }}</span>
            </div>
          </div>
        </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ToggleButton from 'vue-js-toggle-button'
import { isValidCep, isValidCnpj } from '@brazilian-utils/validators'
import Actions from '../../actions/PontoApoioActions'
import MotoristaActions from '../../actions/MotoristaActions'
import { onlyNumbers } from '../../helpers/numbers'

Vue.use(ToggleButton)

export default {
  name: 'novo',
  data () {
    return {
      errorMessage: '',
      errors: {},
      hasError: false,
      cepNaoEncontrado: false,
      registro: {
        cd_ponto_apoio: '',
        descricao: '',
        cnpj: '',
        telefone: '',
        end_cep: '',
        end_logradouro: '',
        end_numero: '',
        end_complemento: '',
        end_bairro: '',
        end_cidade: '',
        end_uf: '',
        end_pais: '1058',
        end_latitude: '',
        end_longitude: '',
        horario_atend_ini: '08:00',
        horario_atend_fim: '18:00',
        horario_indisponivel_ini: '12:00',
        horario_indisponivel_fim: '13:00',
        capacidade_atend_hora: '',
        raio_atuacao: '',
        idc_status: '',
        min_horas_agendamento: '',
        idc_agenda_hora: false,
        dt_inicio_operacao: ''
      }
    }
  },

  mounted () {
    this.$parent.$parent.$data.description = 'Novo'
  },
  methods: {
    voltar () {
      this.$router.push('/ponto-apoio')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.cd_ponto_apoio) {
        this.errors.cd_ponto_apoio = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (this.registro.cd_ponto_apoio.length !== 5) {
        this.errors.cd_ponto_apoio = 'Informe um código com 5 caracteres.'
        this.hasError = true
      }

      const reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/

      if (!this.registro.dt_inicio_operacao.match(reg)) {
        this.errors.dt_inicio_operacao = 'Informe uma data válida.'
        this.hasError = true
      }

      if (!this.registro.descricao) {
        this.errors.descricao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.cnpj) {
        this.errors.cnpj = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (!isValidCnpj(this.registro.cnpj)) {
        this.errors.cnpj = 'CNPJ inválido.'
        this.hasError = true
      }

      if (!this.registro.horario_atend_ini || !this.registro.horario_atend_fim) {
        this.errors.horario_atend = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (this.registro.horario_atend_ini && this.registro.horario_atend_fim) {
        if (onlyNumbers(this.registro.horario_atend_ini) > onlyNumbers(this.registro.horario_atend_fim)) {
          this.errors.horario_atend = 'Horário inválido.'
          this.hasError = true
        }
      }

      if ((this.registro.horario_indisponivel_ini && !this.registro.horario_indisponivel_fim) ||
        (!this.registro.horario_indisponivel_ini && this.registro.horario_indisponivel_fim)) {
        this.errors.horario_indisponivel = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (this.registro.horario_indisponivel_ini && this.registro.horario_indisponivel_fim) {
        if (onlyNumbers(this.registro.horario_indisponivel_ini) > onlyNumbers(this.registro.horario_indisponivel_fim)) {
          this.errors.horario_indisponivel = 'Horário inválido.'
          this.hasError = true
        }
      }

      if (!this.registro.capacidade_atend_hora) {
        this.errors.capacidade_atend_hora = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.raio_atuacao) {
        this.errors.raio_atuacao = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.telefone) {
        this.errors.telefone = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_cep) {
        this.errors.end_cep = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (this.cepNaoEncontrado) {
        this.errors.end_cep = 'CEP não encontrado.'
        this.hasError = true
      }

      if (!this.registro.end_logradouro) {
        this.errors.end_logradouro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_numero) {
        this.errors.end_numero = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_bairro) {
        this.errors.end_bairro = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_cidade) {
        this.errors.end_cidade = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_uf) {
        this.errors.end_uf = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.end_pais) {
        this.errors.end_pais = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.min_horas_agendamento) {
        this.errors.min_horas_agendamento = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },
    gravar () {
      this.validation()

      if (!this.hasError) {
        this.$parent.$parent.$data.showModalLoader = true

        const partes = this.registro.dt_inicio_operacao.split('/')
        const dia = parseInt(partes[0], 10)
        const mes = parseInt(partes[1], 10) - 1
        const ano = parseInt(partes[2], 10)

        const dataLocal = new Date(ano, mes, dia, 0, 0, 0)

        this.registro.dt_inicio_operacao = dataLocal

        Actions.cadastrarPontoApoio({
          cd_ponto_apoio: this.registro.cd_ponto_apoio,
          descricao: this.registro.descricao,
          cnpj: this.registro.cnpj,
          telefone: this.registro.telefone,
          end_cep: this.registro.end_cep,
          end_logradouro: this.registro.end_logradouro,
          end_numero: this.registro.end_numero,
          end_complemento: this.registro.end_complemento,
          end_bairro: this.registro.end_bairro,
          end_cidade: this.registro.end_cidade,
          end_uf: this.registro.end_uf,
          end_pais: this.registro.end_pais,
          end_latitude: this.registro.end_latitude,
          end_longitude: this.registro.end_longitude,
          horario_atend_ini: this.registro.horario_atend_ini,
          horario_atend_fim: this.registro.horario_atend_fim,
          horario_indisponivel_ini: this.registro.horario_indisponivel_ini,
          horario_indisponivel_fim: this.registro.horario_indisponivel_fim,
          capacidade_atend_hora: this.registro.capacidade_atend_hora,
          raio_atuacao: this.registro.raio_atuacao,
          idc_status: this.registro.idc_status,
          min_horas_agendamento: this.registro.min_horas_agendamento,
          idc_agenda_hora: this.registro.idc_agenda_hora,
          dt_inicio_operacao: this.registro.dt_inicio_operacao
        })
        .then(response => {
          this.$parent.$parent.$data.showModalLoader = false
          this.$router.push('/ponto-apoio')
        })
        .catch((error) => {
          const errorMsg = (error.response && error.response.data) ? error.response.data.error : error.message
          this.errorMessage = errorMsg || 'Ocorreu um erro ao gravar o registro.'
          this.$parent.$parent.$data.showModalLoader = false
        })
      }
    },
    pesquisarCEP () {
      if (isValidCep(this.registro.end_cep)) {
        if (this.ultimoCEP !== this.registro.end_cep) {
          this.ultimoCEP = this.registro.end_cep

          this.$parent.$parent.$data.showModalLoader = true

          MotoristaActions.pesquisarCep(this.registro.end_cep)
            .then(res => {
              this.registro.end_logradouro = res.logradouro
              this.registro.end_bairro = res.bairro
              this.registro.end_cidade = res.localidade
              this.registro.end_uf = res.uf

              this.errors.end_cep = null
              this.cepNaoEncontrado = false

              this.$parent.$parent.$data.showModalLoader = false
            })
            .catch(erro => {
              this.registro.end_logradouro = ''
              this.registro.end_bairro = ''
              this.registro.end_cidade = ''
              this.registro.end_uf = ''

              this.errors.end_cep = 'CEP não encontrado.'
              this.cepNaoEncontrado = true

              this.$parent.$parent.$data.showModalLoader = false
            })
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/ponto-apoio/Novo.vue